import clsx from 'clsx'
import React, { CSSProperties, FC, ReactNode } from 'react'

import styles from '@Domains/Header/Features/Bars/Generic.module.scss'

interface GenericBarProps {
  backgroundColor: string
  className?: string
  contentLeft?: ReactNode | undefined
  contentMiddle?: ReactNode | undefined
  contentMobile?: ReactNode | undefined
  contentRight?: ReactNode | undefined
  id: string
  order?: number
  placement: string
  textColor: string
}

const GenericBar: FC<GenericBarProps> = ({
  backgroundColor,
  className,
  contentLeft,
  contentMiddle,
  contentMobile,
  contentRight,
  id,
  order,
  placement,
  textColor,
}) => (
  <div
    className={clsx(
      styles.bar,
      placement === 'top' && styles['placement-top'],
      placement === 'checkout' && styles['placement-checkout'],
      Boolean(contentLeft && (contentMiddle || contentMobile) && contentRight) && styles['columns-3'],
      Boolean(contentLeft && !(contentMiddle || contentMobile) && contentRight) && styles['columns-2'],
      Boolean(!contentLeft && (contentMiddle || contentMobile) && !contentRight) && styles['columns-1'],
      className,
    )}
    id={id}
    style={{
      '--background-color': backgroundColor,
      '--link-color': textColor,
      '--text-color': textColor,
      order,
    } as CSSProperties}
  >
    <div className={styles.wrapper}>
      {contentLeft && <div className={styles.left}>{contentLeft}</div>}
      {contentMiddle && <div className={clsx(styles.middle, styles.desktop)}>{contentMiddle || contentMobile}</div>}
      {contentMobile && <div className={clsx(styles.middle, styles.mobile)}>{contentMobile || contentMiddle}</div>}
      {contentRight && <div className={styles.right}>{contentRight}</div>}
    </div>
  </div>
)

export default GenericBar
